import { openBlock as c, createElementBlock as l, createElementVNode as e } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, o = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M12.816 4.502c.83.78 1.59 1.77 2.26 2.95h-.01c.13.23.13.51 0 .74-1.85 3.26-4.36 5.05-7.07 5.05-1.07 0-2.11-.29-3.09-.83l-1.95 1.95c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.744.744 0 0 1-.03-1.02l11.74-11.74c.3-.25.74-.25 1.02.03.29.29.29.77 0 1.06l-1.81 1.81Zm-3.23 3.32v-.08l-1.66 1.66h.08c.87 0 1.58-.71 1.58-1.58Zm-3.54 3.47c.64.29 1.3.45 1.97.45v.01c2.05 0 4.01-1.39 5.55-3.92-.55-.91-1.16-1.66-1.8-2.26l-.96.96c.19.4.3.84.3 1.3 0 1.7-1.38 3.08-3.08 3.08-.47 0-.9-.12-1.3-.3l-.68.68Z",
  "clip-rule": "evenodd"
}, null, -1), n = /* @__PURE__ */ e("path", { d: "M8.005 3.902c-2.048 0-4.007 1.388-5.547 3.915.38.608.769 1.156 1.187 1.625l-1.06 1.06c-.59-.66-1.15-1.42-1.65-2.31a.75.75 0 0 1 0-.74c1.84-3.26 4.35-5.05 7.07-5.05.77 0 1.51.16 2.24.44l-1.2 1.2c-.34-.08-.69-.14-1.04-.14Z" }, null, -1), s = /* @__PURE__ */ e("path", { d: "M8.006 4.732c-1.7 0-3.08 1.38-3.08 3.08 0 .072.008.14.017.208.004.037.01.074.013.112l3.37-3.37a3.155 3.155 0 0 1-.112-.013 1.591 1.591 0 0 0-.208-.017Z" }, null, -1), d = [
  o,
  n,
  s
];
function i(r, h) {
  return c(), l("svg", t, [...d]);
}
const a = { render: i };
export {
  a as default,
  i as render
};
